import { useState } from 'react'
import styles from "./styles.module.css"
import themes from "../../config/themes"
import { setTheme } from "../../api-client/data"
import dashboardStyles from '../dashboard/styles.module.css'
import { Typography, useMediaQuery } from "@mui/material"
import { useTrigger, Triggers } from "../../stores/dashboard.store"
import { useEffect } from "react"

export default function ThemeSelector() {
    const updateTheme = useTrigger(Triggers.RefreshTheme)
    const [currentTheme, setCurrentTheme] = useState('')

    const getCurrentTheme = () => {
        const body = document.documentElement
        const currentTheme = themes.find((t) => t.className && body.classList.contains(t.className))

        setCurrentTheme(currentTheme?.className)
    }

    const handleThemeChange = async (theme) => {
        await setTheme(theme)
        await updateTheme()
        getCurrentTheme()
    }

    useEffect(() => {
        getCurrentTheme()
    }, [])

    return (
        <div className={dashboardStyles.dashboardContent}>
            <div className={dashboardStyles.dashboardHeader}>
                <div className={dashboardStyles.settingsTitle} style={{ flex: 1 }}>
                    <Typography variant="h6">Appearance</Typography>
                </div>
            </div>
            <div className={dashboardStyles.containerScroll}>
                <div className={styles.grid}>
                    {themes.map((theme) => (
                        <div
                            key={theme.className}
                            className={`${styles.themeOption} ${currentTheme === theme.className ? styles.selected : ""}`}
                            onClick={() => handleThemeChange(theme.className)}
                        >
                            <div className={`${styles.preview} ${theme.className}`}>
                                <div className={`${styles.previewNav} ${theme.className}`}>
                                    <span className={styles.navTitle}>Nura</span>
                                </div>
                                <div className={`${styles.previewBody} ${theme.className}`}>
                                    <div className={`${styles.previewNav2} ${theme.className}`}>
                                        <span>Flow</span>
                                    </div>
                                    <div className={`${styles.previewContent} ${theme.className}`}>
                                        <div className={styles.contentBox}></div>
                                        <div className={styles.buttonMock}></div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.themeName}>
                                {theme.name}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
